import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

type BadgeType = 'risco' | 'estado' | 'criticidade' | 'cobertura' | 'contrato' | 'equipamento';

@Component({
  selector: 'app-status-badge',
  standalone: true,
  imports: [CommonModule],
  template: `<span class="badge" [ngClass]="cssClass">{{ label }}</span>`
})
export class StatusBadgeComponent {
  @Input() value = '';
  @Input() type: BadgeType = 'estado';

  get cssClass(): string {
    return `badge-${this.key}`;
  }

  get key(): string {
    const v = (this.value || '').toUpperCase();
    const map: Record<string, string> = {
      URGENTE: 'urgente', ALTA: 'alta', MEDIA: 'media', MEDIO: 'media',
      CRITICO: 'critico', ALTO: 'alto', MODERADO: 'moderado', BAIXO: 'baixo',
      BOM: 'bom', DESTRUIDO: 'destruido', INATIVO: 'inativo', ATIVO: 'ativo',
      DIURNO: 'diurno', NOTURNO: 'noturno', '24_HORAS': '24h', HORAS_24: '24h',
      EXPIRADO: 'urgente', 'A VENCER': 'alta', ATIVO_CONTRATO: 'ativo',
      PENDENTE: 'pendente', SUSPENSO: 'alta',
    };
    return map[v] || 'moderado';
  }

  get label(): string {
    const v = (this.value || '').toUpperCase();
    const labels: Record<string, string> = {
      MEDIA: 'MÉDIA', HORAS_24: '24H', '24_HORAS': '24H',
      DESTRUIDO: 'DESTRUÍDO', ATIVO: 'ATIVO', INATIVO: 'INATIVO',
      URGENTE: 'URGENTE', ALTA: 'ALTA', BAIXO: 'BAIXO', ALTO: 'ALTO',
      MODERADO: 'MODERADO', CRITICO: 'CRÍTICO', BOM: 'BOM',
      DIURNO: 'DIURNO', NOTURNO: 'NOTURNO', EXPIRADO: 'EXPIRADO',
      PENDENTE: 'PENDENTE', SUSPENSO: 'SUSPENSO',
    };
    return labels[v] || this.value;
  }
}
